import neighborhoodImage from 'assets/img/agent-landing/contact-neighborhood.png';
import React from 'react';
import { ELeadResponseType } from 'types/lead-response';

import AgentLandingLeadForm, { Eyebrow, normalizeAgents } from 'components/AgentLanding/AgentLandingPrimitives';

const Contact = ({ agentLandingPageToken, agentData, marketAreaName }) => {
  const isTeam = normalizeAgents(agentData).length > 1;

  return (
    <>
      <section className="al-contact-hero">
        <div className="al-shell al-contact-grid">
          <div className="al-contact-copy">
            <Eyebrow>Complimentary local valuation</Eyebrow>
            <h1>A clearer picture of what your home is worth.</h1>
            <p className="al-lead">Get a thoughtful, no-pressure property review informed by current neighborhood activity—not a generic online estimate.</p>
            <div className="al-trust-row">
              <div>
                <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m5 12 4 4L19 6" />
                </svg>
                <span>
                  <strong>Local expertise</strong>
                  <small>Reviewed by a real agent</small>
                </span>
              </div>
              <div>
                <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="5" y="10" width="14" height="11" rx="2" />
                  <path d="M8 10V7a4 4 0 0 1 8 0v3" />
                </svg>
                <span>
                  <strong>Private by design</strong>
                  <small>Your information stays secure</small>
                </span>
              </div>
            </div>
            <div className="al-neighborhood-image" style={{ backgroundImage: `url(${neighborhoodImage})` }}>
              <span className="al-image-note">
                <span>Local market focus</span>
                <strong>{marketAreaName || 'Your neighborhood'}</strong>
              </span>
            </div>
          </div>
          <AgentLandingLeadForm
            agentLandingPageToken={agentLandingPageToken}
            agentData={agentData}
            leadResponseType={ELeadResponseType.AgentLandingPropertyReviewRequest}
            title={`Tell ${isTeam ? 'us' : 'me'} about your property`}
            subtitle={`${isTeam ? 'We’ll' : 'I’ll'} follow up personally with next steps and a refined market perspective.`}
            submitLabel="Request my property review"
            successTitle="Thank you — your property review request is on its way."
            successMessage={`${isTeam ? 'We’ll' : 'I’ll'} review what you shared and follow up with a thoughtful local perspective.`}
            showPropertyAddress={false}
            showSellingTimeline={false}
          />
        </div>
      </section>
      <section className="al-process">
        <div className="al-shell">
          <Eyebrow>A more useful valuation</Eyebrow>
          <h2>
            Data starts the conversation.
            <br />
            Local context completes it.
          </h2>
          <div className="al-process-grid">
            <article>
              <span>01</span>
              <h3>
                Tell
                {' '}
                {isTeam ? 'us' : 'me'}
                {' '}
                about your home
              </h3>
              <p>Share a few property details and what you want to understand.</p>
            </article>
            <article>
              <span>02</span>
              <h3>
                {isTeam ? 'We' : 'I'}
                {' '}
                review the market
              </h3>
              <p>Recent sales, active competition, and local demand are considered together.</p>
            </article>
            <article>
              <span>03</span>
              <h3>Get practical next steps</h3>
              <p>Receive a clear value perspective and guidance tailored to your plans.</p>
            </article>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
